import React, { useEffect, useRef, useState } from "react";
import Buttons from "../../../../../../components/ui/button/Buttons";
import FormCreator from "../../../../../../components/finalForms/FormCreator";
import { importModelContractConfig } from "./components/ImportModelContract.formfield.config";
import { useImportModelContractScopesMutation } from "../../../../../../app/services/contractAPI";
import ToastService from "../../../../../../services/toastService/ToastService";

const ImportModelContractCosts = () => {
  const ImportModelContractref = useRef();
  const [formKey, setFormKey] = useState(Date.now());
  const [importModelContractForm, setImportModelContractForm] = useState(importModelContractConfig);

  const [ModelContractScopes, {
    isSuccess: isImported,
    data: importData
  }] = useImportModelContractScopesMutation();

  const handleSaveClick = () => {
    const formData = ImportModelContractref.current.getFormData();
    if (formData?.importContractCost) {
      const file = formData.importContractCost[0].base64Data;
      const base64Data = file.split(",")[1];
      const req = { base64File: base64Data };
      ModelContractScopes(req);
    }
  }

  const resetForm = () => {
    if (ImportModelContractref.current?.resetForm) {
      ImportModelContractref.current.resetForm();
    }

    const form = { ...importModelContractConfig };
    form.initialState = { ...importModelContractConfig.initialState };
    setImportModelContractForm(form);
    setFormKey(Date.now());
  };

  useEffect(() => {
    if (isImported && importData) {
      if (importData?.message?.includes("Missing required")) {
        ToastService.warning(importData?.message);
      } else {
        ToastService.success(importData?.message);
        resetForm();
      }
    }
  }, [isImported, importData]);

  return (
    <div className="p-2">
      <FormCreator
        key={formKey}
        ref={ImportModelContractref}
        config={importModelContractForm}
      />
      <div className="d-flex justify-content-center button-submit mb-2 mt-3">
        <Buttons
          buttonText="Import"
          buttonTypeClassName="btn blue-btn w-full"
          onClick={handleSaveClick}
        />
        <Buttons
          buttonText="Clear"
          buttonTypeClassName="btn secondary-btn ml-4"
          onClick={resetForm}
        />
      </div>
    </div>
  );
};

export default ImportModelContractCosts;